<script setup>
const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <button class="more-button">
    <span v-if="props.loading">
      <img
        class="more-button__spinner"
        src="~/assets/images/spinner.svg"
        alt="loading"
      />
    </span>
    <span v-else>
      Загрузить <br />
      еще
    </span>
  </button>
</template>

<style lang="postcss" scoped>
.more-button {
  width: 164px;
  height: 164px;
  text-align: center;
  font-family: var(--title-font-family);
  font-size: 18px;
  line-height: 24px;
  border-radius: 50%;
  color: var(--accent-color);
  background-color: rgba(var(--accent-color--rgb), 10%);
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;

  span {
    display: block;
  }

  @media (--small-vp) {
    width: 124px;
    height: 124px;
    font-size: 14px;
    line-height: 18px;
  }

  &:hover,
  &:active {
    opacity: 0.6;
    display: block;
  }

  &__spinner {
    width: 64px;
    height: 64px;
    margin: auto;
    opacity: 0.6;
  }
}
</style>
